import { SalesByUserTable } from './SalesByUserTable'
import { withSalesByUserTable } from './withSaleByUserTable'

const ConnectedSalesByUserTable = withSalesByUserTable(SalesByUserTable)
export { ConnectedSalesByUserTable as SalesByUserTable }
